import {useTranslation} from "react-i18next";
import {Button, Card} from "antd";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {DataGridProvider, useDataGrid} from "../../core/components/data-grid/DataGridContext";
import DeviceGrid from "../../app/device/device-data-grid/DeviceGrid";
import DeviceFilter from "../../app/device/device-data-grid/DeviceFilter";
import Flex from "../../core/components/Flex";
import CardTitle from "../../core/components/CardTitle";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";
import {useModal} from "../../core/context/ModalContext";
import DeviceCreateEdit from "../../app/device/DeviceCreateEdit";

export default function DeviceGridPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('Devices')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            <DataGridProvider>
                <DeviceGridContent />
            </DataGridProvider>
        </>
    )
}

function DeviceGridContent() {
    const {t} = useTranslation();
    const {openModal, closeModal} = useModal();
    const {refreshDataGrid} = useDataGrid();

    const handleNewDevice = () => {
        openModal(t('New Device'), (
            <DeviceCreateEdit
                onSaved={() => {
                    closeModal();
                    refreshDataGrid();
                }}
            />
        ));
    }

    const Title = () => {
        return (
            <Flex justifyContent={'space-between'}>
                <CardTitle title={t('Devices')} />
                <Button onClick={handleNewDevice}>
                    {t('New Device')}
                </Button>
            </Flex>
        )
    }

    return (
        <LayoutWithSider
            fullWidth={true}
            sidebarTitle={t('Device Filter')}
            sidebarComponent={(
                <DeviceFilter/>
            )}
        >
            <Card title={<Title />}>
                <DeviceGrid />
            </Card>
        </LayoutWithSider>
    )
}
